// RejectServiceOrderReqWithDiscCustPage.js
import React, { useEffect, useState } from "react";
import { FaTimes, FaBan } from "react-icons/fa";
import "../../../invite.css";

const RejectServiceOrderReqWithDiscCustPage = () => {
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const mainId = queryParams.get("pvid");
    const custid = queryParams.get("uid");

    const handleReject = async () => {
      if (!BASE_URL) {
        console.error("❌ Missing REACT_APP_API_URL in .env");
        setSuccess(false);
        setErrorMsg("Configuration error. Please contact support.");
        setLoading(false);
        return;
      }

      if (!mainId) {
        console.warn("❌ Missing mainId in query string");
        setSuccess(false);
        setErrorMsg("Missing Work Order Request ID.");
        setLoading(false);
        return;
      }
      if (!custid) {
        console.warn("❌ Missing custid in query string");
        setSuccess(false);
        setErrorMsg("Missing Customer ID.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${BASE_URL}/WorkOrderRequest/Approve_WorkOrderRequest_By_Customer`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              workOrderRequestID: parseInt(mainId, 10),
              customerID: parseInt(custid, 10),
              statusID: 2, // 2 = Reject
            }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(`Rejection failed with status ${response.status}`);
        }

        if (data.isSuccess) {
          setSuccess(true);
        } else {
          setSuccess(false);
          setErrorMsg(data.message || "Rejection failed.");
        }
      } catch (err) {
        console.error("❌ Error in handleReject:", err);
        setSuccess(false);
        setErrorMsg(err.message || "Unexpected error.");
      } finally {
        setLoading(false);
      }
    };

    handleReject();
  }, [BASE_URL]);

  if (loading) {
    return (
      <div className="center-screen">
        <div className="loader-container" aria-live="polite">
          <img
            src="/Montdor_1.png"
            alt="Company Logo"
            className="company-logo"
            onError={(e) => (e.target.style.display = "none")}
          />
          <div className="spinner"></div>
          <p className="loader-text">Processing your request...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="center-screen" style={{ backgroundColor: "#2c2139" }}>
      <div className="card-box">
        {success ? (
          <>
            <div className="icon">
              <FaBan size={48} color="#e74c3c" />
            </div>
            <h2 className="card-title">Rejected</h2>
            <p className="card-msg">Additional Item has been Rejected.</p>
          </>
        ) : (
          <>
            <div className="icon">
              <FaTimes size={48} color="#888" />
            </div>
            <h2 className="card-title">Error</h2>
            <p className="card-msg">
              {errorMsg || "Unable to reject Additional Item."}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default RejectServiceOrderReqWithDiscCustPage;
